export default "__VITE_ASSET__BVUNOmzz__"